import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { PropTableValues } from '../../src/components';
import { iconColors, namedIconSizes, numericIconSizes } from '@primer/react-brand';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Icon} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Icon icon={ZapIcon} />
`}</code></pre>
    <h3>{`Colors`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Stack direction="horizontal" gap={16} flexWrap="wrap" padding="none">
  <Icon icon={RocketIcon} color="default" />
  <Icon icon={RocketIcon} color="blue" />
  <Icon icon={RocketIcon} color="coral" />
  <Icon icon={RocketIcon} color="green" />
  <Icon icon={RocketIcon} color="gray" />
  <Icon icon={RocketIcon} color="indigo" />
  <Icon icon={RocketIcon} color="lemon" />
  <Icon icon={RocketIcon} color="lime" />
  <Icon icon={RocketIcon} color="orange" />
  <Icon icon={RocketIcon} color="pink" />
  <Icon icon={RocketIcon} color="purple" />
  <Icon icon={RocketIcon} color="red" />
  <Icon icon={RocketIcon} color="teal" />
  <Icon icon={RocketIcon} color="yellow" />
</Stack>
`}</code></pre>
    <h3>{`With background`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Stack direction="horizontal" gap={16} flexWrap="wrap" padding="none">
  <Icon icon={RocketIcon} hasBackground color="default" />
  <Icon icon={RocketIcon} hasBackground color="blue" />
  <Icon icon={RocketIcon} hasBackground color="coral" />
  <Icon icon={RocketIcon} hasBackground color="green" />
  <Icon icon={RocketIcon} hasBackground color="gray" />
  <Icon icon={RocketIcon} hasBackground color="indigo" />
  <Icon icon={RocketIcon} hasBackground color="lemon" />
  <Icon icon={RocketIcon} hasBackground color="lime" />
  <Icon icon={RocketIcon} hasBackground color="orange" />
  <Icon icon={RocketIcon} hasBackground color="pink" />
  <Icon icon={RocketIcon} hasBackground color="purple" />
  <Icon icon={RocketIcon} hasBackground color="red" />
  <Icon icon={RocketIcon} hasBackground color="teal" />
  <Icon icon={RocketIcon} hasBackground color="yellow" />
</Stack>
`}</code></pre>
    <h3>{`Sizes`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Stack direction="vertical">
  <Icon icon={CopilotIcon} size="small" />
  <Icon icon={CopilotIcon} size="medium" />
  <Icon icon={CopilotIcon} size="large" />
</Stack>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`Icon`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`icon`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`OcticonProps`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`React.ReactElement<OcticonProps>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The Octicon component to render`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`color`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={iconColors} commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`'default'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The color of the icon`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[...namedIconSizes, ...numericIconSizes]} commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`'small'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The size of the icon`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`hasBackground`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether to show a background behind the icon`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Additional CSS class for the icon`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`All other props are forwarded to the underlying SVG element.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      